import React from 'react';
import { Field } from 'react-final-form';

import { required } from 'Shared/utils/formValidations';
import FormEmailsSelection from 'Shared/components/FormComponents/FormEmailsSelection';

import PersonalMessageForm from './PersonalMessageForm/PersonalMessageForm';

function FormFields() {
  return (
    <div className="my-3">
      <FormEmailsSelection selector="inviteeEmails" />
      <Field
        name="personalMessage"
        component={PersonalMessageForm}
        validate={required}
        selectorForWorkspaces="recurringMeetings"
      />
    </div>
  );
}

export default FormFields;
